import { Api } from '@/services/Api'

export default {
  wsTypeData (plantId) {
    return Api().get(`/api/v1.0/wsType/${plantId}`)
  },
  wsData (param) {
    return Api().post('/api/v1.0/wsGraph', param)
  },
  wsBoxData (param) {
    return Api().post('/api/v1.0/wsBox', param)
  },
  wsRangeBoxData (param) {
    return Api().post('/api/v1.0/wsRangeBox', param)
  },
  wsDataTable (param) {
    return Api().post('/api/v1.0/wsTable', param)
  },
  wsDataTableAll (param) {
    return Api().post('/api/v1.0/wsTable/group', param)
  },
  wsList (plantId) {
    return Api().get('/api/v1.0/ws-config/' + plantId)
  }
}
